import { TypeSetting } from '../../interfaces/Settings/settings'
import { TypeSettingAction } from '../actions/typeSettingActions'
import { GET_TYPE_SETTING_EXITO } from '../types/typeSettingActionsTypes'

export interface TypeSettingState {
  typeSettingState: {
    typeSetting: TypeSetting[] | undefined
    error?: string | undefined
  }
}

const initialState: TypeSettingState = {
  typeSettingState: { typeSetting: undefined, error: '' }
}

export const typeSettingReducer = (
  state: TypeSettingState = initialState,
  action: TypeSettingAction
): TypeSettingState => {
  if (action.type === GET_TYPE_SETTING_EXITO) {
    return {
      ...state,
      typeSettingState: {
        typeSetting: action.error
          ? state.typeSettingState.typeSetting
          : action.typeSetting,
        error: action.error
      }
    }
  }
  return state
}